import { render, staticRenderFns } from "./TaskItemGroup.vue?vue&type=template&id=fb4d5170"
import script from "./TaskItemGroup.vue?vue&type=script&lang=js"
export * from "./TaskItemGroup.vue?vue&type=script&lang=js"
import style0 from "./TaskItemGroup.vue?vue&type=style&index=0&id=fb4d5170&prod&lang=scss"
import style1 from "./TaskItemGroup.vue?vue&type=style&index=1&id=fb4d5170&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports